<template>
  <v-app v-if="articleInfoValue">
    <v-container fluid class="article-actions">
      <v-row>
        <v-col cols="2">
          <v-subheader>عنوان</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-text-field
            class="subtitle-1"
            placeholder="عنوان"
            v-model="title"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>ایمیل</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-text-field placeholder="ایمیل" v-model="email"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>آدرس</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-text-field placeholder="آدرس" v-model="address"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>مکان</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-text-field placeholder="مکان" v-model="location"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>شماره تلفن</v-subheader>
        </v-col>
        <v-col cols="8">
          <v-text-field placeholder="شماره تلفن" v-model="phone"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>تصویر</v-subheader>
        </v-col>
        <v-col cols="8">
          <input type="file" @change="onFileSelected" />
          <img :src="image" height="200" alt="" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>توضیح</v-subheader>
        </v-col>
        <v-col cols="8">
          <ckeditor v-model="description" :config="editorConfig"></ckeditor>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-btn
          class="ml-4 white--text font-weight-bold pink darken-1"
          @click="editHandler"
        >
          ثبت کردن
        </v-btn>
        <router-link to="/contact-info">
          <v-btn class="white--text font-weight-bold indigo lighten-2">
            انصراف
          </v-btn>
        </router-link>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  created() {
    this.title = this.articleInfoValue.title;
    this.description = this.articleInfoValue.description;
    this.address = this.articleInfoValue.address;
    this.phone = this.articleInfoValue.phone;
    this.location = this.articleInfoValue.location;
    this.email = this.articleInfoValue.email;
    this.image = this.articleInfoValue.image;
  },
  data() {
    return {
      address: "",
      title: "",
      description: "",
      location: "",
      editorConfig: {
        versionCheck: false,
      },
      phone: "",
      email: "",
      image: null,
    };
  },
  computed: {
    ...mapGetters(["tokenValue", "articleInfoValue"]),
  },
  methods: {
    onFileSelected(event) {
      this.icon = event.target.files[0];
    },
    async editHandler() {
      await axios
        .put(
          "http://api.karaclub.com/api/ContactUsInfo/Edit",
          {
            address: this.address,

            title: this.title,
            description: this.description,
            email: this.email,
            phone: this.phone,
            location: this.location,
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        )
        .then(() => {
          const fd = new FormData();
          fd.append("image", this.image);
          axios
            .post(`http://api.karaclub.com/api/ContactUsInfo/UploadImage`, fd, {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("token")}`,
                "Content-Type": "multipart/form-data",
              },
            })
            .then(() => {
              this.$router.push("/contact-info");
            });
        });
    },
  },
};
</script>

<style>
.article-actions {
  background: #ffffff;
  height: auto;
}
.v-input__control {
  direction: ltr;
}
.v-input__slot {
  flex-direction: row-reverse;
}
.v-application--wrap {
  min-height: auto !important;
}
.theme--light.v-input input {
  text-align: right;
}
.theme--light.v-subheader {
  font-weight: 900;
  font-size: 14px;
}
</style>
